export const FIELD_SAVER = 'questionnaire/FIELD_SAVER';
export const FIELD_ERROR = 'questionnaire/FIELD_ERROR';
